import { gql } from '@apollo/client'

export const APPROVE_TEST_SESSION = gql`
  mutation ApproveTestSession($inputData: ApproveTestSessionInput!) {
    approveTestSession(inputData: $inputData) {
      id
    }
  }
`
